import { render, staticRenderFns } from "./ShopCustom.vue?vue&type=template&id=6cd7bd20&scoped=true"
import script from "./ShopCustom.vue?vue&type=script&lang=js"
export * from "./ShopCustom.vue?vue&type=script&lang=js"
import style0 from "./ShopCustom.vue?vue&type=style&index=0&id=6cd7bd20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd7bd20",
  null
  
)

export default component.exports